export default [
    {
        name: 'GroupPostDetailPageComments',
        path: 'comments',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPostDetailPageComments'),
        props: true, meta: {name: 'comments'}
    },
    {
        name: 'GroupPostDetailPageInfo',
        path: 'detail',
        component: () => import(/* webpackChunkName: "groupPage" */ './GroupPostDetailPageInfo'),
        props: true,
        meta: {name: 'info'}
    },
];
